import React, { useState } from "react";
import { useConfig } from "./ConfigContext";
import "./funnel.css";
import { host } from "./globalVariables";

const steps = [
   [
      {
         type: "form",
         heading: "Wer bist du?",
         content: [
            { heading: "Vorname", type: "text" },
            { heading: "Nachname", type: "text" },
         ],
      },
   ],
   [
      {
         type: "form",
         heading: "Wie können wir dich erreichen?",
         content: [
            { heading: "E-Mail", type: "email" },
            { heading: "Telefon", type: "phone" },
         ],
      },
   ],
   [
      {
         type: "buttongroup",
         heading: "Was wünschen Sie?",
         content: [{ heading: "Besichtigung" }, { heading: "Exposé" }, { heading: "Sonstiges" }],
      },
   ],
   [{ heading: "Exposé", type: "button" }],
];
export default function Funnel({}) {
   const [currentStep, setCurrentStep] = useState(0);
   const config = useConfig();
   return (
      <div className="funnel-main">
         <div className="funnel-card">
            <img
               src={host + "/images/logo-dark-long.svg"}
               // width="150"
               //  height="32"
               style={{ borderRadius: "8px", background: "#333", padding: "10px" }}
               className="d-inline-block align-top w-100"
               alt="logo"
            />
            {steps[currentStep].map((fieldItem) => {
               return (
                  <div>
                     {fieldItem.type === "text" && (
                        <label>
                           {fieldItem.heading}
                           <input type={fieldItem.type}></input>
                        </label>
                     )}
                     {fieldItem.type === "button" && <button>{fieldItem.heading}</button>}
                     {fieldItem.type === "form" && (
                        <div className="funnel-form">
                           <h4>{fieldItem.heading}</h4>
                           {fieldItem.content.map((contentItem) => {
                              return (
                                 <div class="input-group">
                                    <label for={contentItem.heading}>
                                       {contentItem.heading}
                                       <input
                                          type={contentItem.type}
                                          id={contentItem.heading}
                                          placeholder=" "
                                          autoComplete="off"
                                          // required
                                       />
                                    </label>
                                 </div>
                              );
                           })}
                        </div>
                     )}
                     {fieldItem.type === "buttongroup" && (
                        <div className="funnel-buttongroup">
                           <h3>{fieldItem.heading}</h3>
                           {fieldItem.content.map((contentItem) => {
                              return <button>{contentItem.heading}</button>;
                           })}
                        </div>
                     )}
                  </div>
               );
            })}

            <div className="nav-buttons">
               <button
                  onClick={() => {
                     setCurrentStep((prev) => (prev > 0 ? prev - 1 : prev));
                  }}
               >
                  Zurück
               </button>
               {currentStep < steps.length - 1 && (
                  <button
                     onClick={() => {
                        setCurrentStep((prev) => (prev <= steps.length ? prev + 1 : prev));
                     }}
                  >
                     Weiter
                  </button>
               )}
               {currentStep === steps.length - 1 && (
                  <button
                     onClick={() => {
                        setCurrentStep((prev) => (prev <= steps.length ? prev + 1 : prev));
                     }}
                  >
                     Absenden
                  </button>
               )}
            </div>
         </div>
      </div>
   );
}
